import { apiRoutes } from '@socialfy/api-contract';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { activityPollMs } from '@/vorgang/abbildungen';
import { useApiQuery } from './query';
import { useSession } from './session';

/**
 * „Was passiert gerade“ (`GET /activity`): fragt alle 5 Sekunden nach, solange etwas läuft, sonst einmal pro Minute.
 * Endet ein Vorgang (es lief etwas, jetzt nichts mehr), laden die Seiten ihre Daten neu: aus dem Lauf sind neue
 * Einordnungen, Funde oder Gespräche geworden. Hülle, Streifen und Seiten teilen sich dieselbe Abfrage.
 */
export function useActivity() {
  const session = useSession();
  const query = useApiQuery(apiRoutes.core.getActivity, undefined, {
    enabled: session.status === 'ready',
    refetchInterval: activityPollMs,
  });
  const queryClient = useQueryClient();
  const wasRunning = useRef(false);
  const running = query.data === undefined ? undefined : query.data.running.length > 0;
  useEffect(() => {
    if (running === undefined) {
      return;
    }
    if (wasRunning.current && !running) {
      void queryClient.invalidateQueries({
        predicate: (q) => q.queryKey[0] !== 'core.getActivity',
      });
    }
    wasRunning.current = running;
  }, [running, queryClient]);
  return query;
}
